import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const dialog = (
  icon: "error" | "success" | "info",
  title: string,
  html: any,
  loading?: boolean,
  handleClose?: () => void,
  width = "43rem",
  showConfirmButton = false
) => {
  MySwal.fire({
    width,
    icon,
    title,
    html,
    didOpen: () => {
      loading && MySwal.showLoading();
    },
    didClose: handleClose,
    showConfirmButton,
    allowOutsideClick: false,
  });
  return MySwal;
};

export default dialog;
